export const formatWorkflowId = (workflowId: string) => {
	if (!workflowId) return undefined;
	const firstDashIndex = workflowId.indexOf('-');
	if (firstDashIndex === -1) return workflowId;
	return workflowId.substring(firstDashIndex + 1);
};
